import React from 'react';
import { Box, Grid, Typography, styled, useTheme } from '@mui/material';
import Footer from '@shared/layout/Footer';

import Header from '@shared/layout/Header';

import Title from '@shared/components/Title';
import CompanyImage from '@shared/assets/company.png';
import CompanyImage2 from '@shared/assets/company1.png';
import Etica from '@shared/assets/etica.svg';
import Compromiso from '@shared/assets/compromiso.svg';
import Equipo from '@shared/assets/equipo.svg';
import Transparencia from '@shared/assets/transparencia.svg';
import Vocacion from '@shared/assets/vocacion.svg';
import { sxStyle } from './styles';

const BodyContainer = styled('div')(() => ({
  backgroundColor: '#F6F6F6',
}));

export default () => {
  const theme = useTheme();

  return (
    <>
      <Header />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        style={{ backgroundColor: '#E5E5E5' }}
      >
        <Grid container direction="column">
          <BodyContainer>
            <Grid container direction="row">
              <Grid container item xs={12} lg={8}>
                <Grid item xs={12} sx={sxStyle.companyValuesContainer}>
                  <Title title={'Empresa'} color={theme.primary} />

                  <Typography variant="body1" sx={sxStyle.companyText}>
                    En Viajes TDH asesoramos sobre destinos turísticos, pero
                    sobre todo, disfrutamos de compartir la fabulosa experiencia
                    de viajar. Nuestro compromiso es poner a tu disposición
                    conocimiento, vivencias, tecnología y profesionalismo para
                    hacer realidad tu viaje.
                  </Typography>
                </Grid>
                <Grid item container sm={12} md={4} sx={sxStyle.womanImgMobile}>
                  <Grid item sm={12} md={10}>
                    <img
                      src={CompanyImage}
                      style={{
                        borderRadius: 5,
                        width: '100%',
                        height: '100%',
                        maxHeight: '450px',
                        maxWidth: '400px',
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    ...sxStyle.companyValuesContainer,
                    ...sxStyle.backroundMobile,
                  }}
                >
                  <Grid item container direction="column">
                    <Typography
                      variant="h6"
                      style={{
                        color: 'black',
                        fontWeight: 'bold',
                        paddingBottom: 20,
                        fontSize: '25px',
                      }}
                    >
                      Valores
                    </Typography>
                    <Grid
                      item
                      container
                      direction="row"
                      style={{ marginBottom: 16 }}
                    >
                      <Grid item xs={6} container direction="row">
                        <div
                          style={{
                            backgroundColor: theme.primary,
                            marginBottom: 5,
                            borderRadius: '100%',
                            marginRight: 10,
                            width: 35,
                            height: 35,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={Etica}
                            style={{ width: '40px', height: '40px' }}
                          />
                        </div>
                        <Typography
                          variant="body1"
                          style={{ color: '#000000' }}
                        >
                          Ética
                        </Typography>
                      </Grid>
                      <Grid item xs={6} container direction="row">
                        <div
                          style={{
                            backgroundColor: theme.primary,
                            borderRadius: '100%',
                            marginRight: 10,
                            width: 35,
                            height: 35,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={Transparencia}
                            style={{ width: '40px', height: '40px' }}
                          />
                        </div>
                        <Typography
                          variant="body1"
                          style={{ color: '#000000' }}
                        >
                          Transparencia
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="row"
                      style={{ marginBottom: 16 }}
                    >
                      <Grid item xs={6} container direction="row">
                        <div
                          style={{
                            backgroundColor: theme.primary,
                            marginBottom: 5,
                            borderRadius: '100%',
                            marginRight: 10,
                            width: 35,
                            height: 35,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={Compromiso}
                            style={{ width: '40px', height: '40px' }}
                          />
                        </div>
                        <Typography
                          variant="body1"
                          style={{ color: '#000000' }}
                        >
                          Compromiso
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        container
                        direction="row"
                        style={{ flexWrap: 'nowrap' }}
                      >
                        <div
                          style={{
                            backgroundColor: theme.primary,
                            borderRadius: '100%',
                            marginRight: 10,
                            width: 35,
                            height: 35,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={Vocacion}
                            style={{ width: '40px', height: '40px' }}
                          />
                        </div>
                        <Typography
                          variant="body1"
                          style={{ color: '#000000' }}
                        >
                          Vocación de servicio
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item container direction="row">
                      <div
                        style={{
                          backgroundColor: theme.primary,
                          borderRadius: '100%',
                          marginRight: 10,
                          width: 35,
                          height: 35,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={Equipo}
                          style={{ width: '40px', height: '40px' }}
                        />
                      </div>
                      <Typography variant="body1" style={{ color: '#000000' }}>
                        Espíritu de equipo
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={sxStyle.valuesSpaceBotom}
                  item
                  xs={12}
                ></Grid>
              </Grid>
              <Grid item container sm={12} md={4} sx={sxStyle.womanImgDesktop}>
                <Grid item sm={12} md={10}>
                  <img
                    src={CompanyImage}
                    style={{
                      borderRadius: 5,
                      width: '100%',
                      height: '100%',
                      maxHeight: '450px',
                      maxWidth: '400px',
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </BodyContainer>

          <BodyContainer>
            <Grid container direction="row" sx={sxStyle.goalsSectionContainer}>
              <Grid
                item
                container
                sm={12}
                md={4}
                sx={{
                  ...sxStyle.menImgContainer,
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item sm={12} md={10}>
                  <Box
                    component="img"
                    src={CompanyImage2}
                    sx={sxStyle.menImg}
                    alt="company"
                  />
                </Grid>
              </Grid>
              <Grid item sm={12} md={6} lg={8} sx={sxStyle.goalsContainer}>
                <Typography
                  variant="h6"
                  style={{
                    color: 'black',
                    fontWeight: 'bold',
                    paddingBottom: 20,
                    fontSize: '25px',
                  }}
                >
                  Objetivos
                </Typography>
                <Grid container sx={sxStyle.goalsItemContainer}>
                  <Grid>
                    <Box sx={sxStyle.diamond} />
                  </Grid>
                  <Typography variant="body1" sx={sxStyle.goalsText}>
                    Asesorar eficientemente, logrando la propuesta de viaje
                    adecuada a la necesidad del pasajero.
                  </Typography>
                </Grid>
                <Grid container sx={sxStyle.goalsItemContainer}>
                  <Grid>
                    <Box sx={sxStyle.diamond} />
                  </Grid>
                  <Typography variant="body1" sx={sxStyle.goalsText}>
                    Garantizar la satisfacción de quienes nos eligen.
                  </Typography>
                </Grid>

                <Grid container sx={sxStyle.goalsItemContainer}>
                  <Grid>
                    <Box sx={sxStyle.diamond} />
                  </Grid>
                  <Typography variant="body1" sx={sxStyle.goalsText}>
                    Enriquecer la vida de las personas, logrando que cada viaje
                    se convierta en una experiencia única.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </BodyContainer>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};
